module.exports = __webpack_public_path__ + "static/media/processing.d6888787.svg";